import React, { useEffect, useState } from 'react';

export default function RechargeModal({ onClose, onGoRecharge, text }) {


  const [title, setTitle] = useState('');

  useEffect(() => {
    if (text.includes("expiraram")) {
      setTitle("Crédito Expirado")
    }
  }, [])
  return (
    <div className="modalOverlay" role="dialog" aria-label="Saldo insuficiente" style={overlayStyle}>
      <div className="modalContent" style={modalStyle}>
        <h3 style={titleStyle}>{title}</h3>
        <p>{text}</p>
        <div style={buttonsStyle}>
          <button onClick={onClose} style={buttonStyle}>Fechar</button>
          <button onClick={onGoRecharge} style={primaryButtonStyle}>Ir para recargas</button>
        </div>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(0,0,0,0.5)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
};
const modalStyle = {
  width: '420px',
  maxWidth: '90%',
  background: '#fff',
  padding: '20px',
  borderRadius: '8px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
};
const titleStyle = {
  margin: 0,
  marginBottom: 8,
};
const buttonsStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 10,
  marginTop: 12,
};
const buttonStyle = {
  padding: '8px 12px',
  border: '1px solid #ccc',
  borderRadius: '4px',
  background: '#fff',
  cursor: 'pointer',
};
const primaryButtonStyle = {
  padding: '8px 12px',
  border: 'none',
  borderRadius: '4px',
  background: '#007bff',
  color: '#fff',
  cursor: 'pointer',
};
